import React from "react";
import Constaint from "./Constaint";
import styled from "styled-components";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoInstagram } from "react-icons/io";
import { TfiLinkedin } from "react-icons/tfi";
import { useNavigate } from "react-router-dom";
import { FaYoutube } from "react-icons/fa6";
import { WebPaths } from "../../../../routes/data";
import Colors from "../../../../styles/Colors";
import { ReactComponent as Logo } from "../../../../images/icons/logo.svg";
import { RiFacebookFill } from "react-icons/ri";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Constaint>
        <Container>
          <TopBar>
            <Logo />
            <SocialsWrapper>
              <a
                href="https://linkedin.com/company/seamlessvisa/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <TfiLinkedin />
              </a>
              <a
                href="https://x.com/seamlessvisa_?s=21&t=fIKPYb2-339hoq41xEiiWw"
                target="_blank"
                rel="noreferrer"
                aria-label="X / Twitter"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://web.facebook.com/profile.php?id=61555803434533"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <RiFacebookFill />
              </a>
              <a
                href="https://www.instagram.com/seamlessvisa_?igsh=OGNrdG9qdDRtN213&utm_source=qr"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <IoLogoInstagram />
              </a>
              <a
                href="https://www.youtube.com/@SeamlessVisa"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
            </SocialsWrapper>
          </TopBar>

          <Columns>
            <QuickLinks>
              <ColumnHeader>Services</ColumnHeader>
              <MiddleLinks onClick={() => navigate(WebPaths.Academy)}>
                Study Abroad
              </MiddleLinks>
              <MiddleLinks onClick={() => navigate(WebPaths.VisaServices)}>
                Visa Processing
              </MiddleLinks>
              <MiddleLinks onClick={() => navigate(WebPaths.FiBiAi)}>
                FiBi Interview Trainer
              </MiddleLinks>
            </QuickLinks>

            <QuickLinks>
              <ColumnHeader>Legal</ColumnHeader>
              <MiddleLinks href="https://app.termly.io/document/acceptable-use/f015bdfa-e9e6-48b2-838c-f5f672992aa9">
                Acceptable Use Policy
              </MiddleLinks>
              <MiddleLinks href="https://app.termly.io/document/privacy-policy/22fda0c1-0085-4dac-aabd-11a41a97895a">
                Privacy Policy
              </MiddleLinks>
              <MiddleLinks href="https://app.termly.io/document/terms-of-service/52cfeaf3-bc98-4aee-8e68-ae9526870a50">
                Terms of Use
              </MiddleLinks>
              <MiddleLinks
                href="/guarantee-policy"
                target="_blank"
                rel="noreferrer"
              >
                Guarantee Policy
              </MiddleLinks>
              <MiddleLinks href="https://app.termly.io/document/disclaimer/17049508-9dd3-44ff-9249-dd61cf7e5868">
                Disclaimer
              </MiddleLinks>
              <MiddleLinks
                href={WebPaths.AiPolicy}
                target="_blank"
                rel="noreferrer"
              >
                Use of AI Tools Policy
              </MiddleLinks>
            </QuickLinks>

            <QuickLinks>
              <ColumnHeader>Support</ColumnHeader>
              <MiddleLinks
                onClick={() => navigate(`${WebPaths.Help}/?contact=true`)}
              >
                Contact Us
              </MiddleLinks>
              <MiddleLinks onClick={() => navigate(WebPaths.FAQs)}>
                FAQs
              </MiddleLinks>
              <MiddleLinks onClick={() => navigate(WebPaths.Help)}>
                Help
              </MiddleLinks>
              <MiddleLinks
                onClick={() =>
                  window.open("http://blog.seamlessvisa.com", "_blank")
                }
              >
                Blog
              </MiddleLinks>
            </QuickLinks>
          </Columns>

          <SubBox>
            <Disclaimer>
              <p>
                SeamlessVisa is not a law firm, and nothing on this site should
                be taken as legal advice or as creating an attorney-client
                relationship. Our services are designed to assist with the
                preparation and organisation of immigration applications. For
                advice specific to your situation, please consult a licensed
                immigration attorney.
              </p>
            </Disclaimer>
            <Copyright>
              © {new Date().getFullYear()} SeamlessVisa Inc.
            </Copyright>
          </SubBox>
        </Container>
      </Constaint>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  background-color: ${Colors.DarkB3};
`;

const Container = styled.div`
  padding-top: 64px;
  padding-bottom: 41px;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 48px;

  flex-direction: column;
  gap: 24px;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    gap: 0;
  }
`;

const SocialsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  & > a {
    color: ${Colors.Black1A};
    transition: 0.3s all ease;

    & > svg {
      height: 24px;
      width: 24px;
    }

    &:hover {
      color: ${Colors.Black};
    }
  }
`;

const Columns = styled.div`
  display: flex;
  gap: 48px;
  justify-content: space-between;

  flex-direction: column;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    gap: 32px;
  }

  @media only screen and (min-width: 1024px) {
    gap: 80px;
  }
`;

const ColumnHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${Colors.Black1A};
  margin-bottom: 16px;
`;

const QuickLinks = styled.div`
  flex: 1;

  & > a,
  & > div[role="button"],
  & > a[role="button"] {
    display: block;
    font-size: 0.9rem;
    margin: 6px 0;
    padding: 4px 0;
  }
`;

const MiddleLinks = styled.a`
  font-weight: 400;
  line-height: 1.6;
  color: ${Colors.Black1A};
  text-decoration: none;
  display: block;
  font-size: 0.9rem;
  margin: 6px 0;
  cursor: pointer;

  &:hover {
    color: ${Colors.Black};
    text-decoration: underline;
  }
`;

const SubBox = styled.div`
  border-top: 1px solid ${Colors.Dark6B};
  display: flex;

  font-size: 1.125rem;
  line-height: 1.375rem;
  font-weight: 400;
  letter-spacing: 0em;
  margin-top: 64px;
  color: ${Colors.Black1A};

  padding-top: 2rem;

  flex-direction: column;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }

  @media only screen and (min-width: 768px) {
    justify-content: space-between;
  }
`;

const Disclaimer = styled.div`
  flex: 1;
  margin-bottom: 2rem;

  @media only screen and (min-width: 768px) {
    flex: 0.6;
  }

  & > p {
    font-size: 0.85rem;
  }
`;

const Copyright = styled.div``;
